/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface LanguageProficiencyDTO {
  languageCode: string;
  proficiencyId: number;
  languageName: string;
  proficiencyName: string;
}
const LanguageProficiencyDTO = {
  create: (initValues?: Partial<LanguageProficiencyDTO> | null): LanguageProficiencyDTO => {
    const defaults: LanguageProficiencyDTO = {
      languageCode: "",
      proficiencyId: 0,
      languageName: "",
      proficiencyName: "",
    };
    const fixedValues: Partial<LanguageProficiencyDTO> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default LanguageProficiencyDTO;
